export default __webpack_public_path__ + "static/sesame-banner-8183b6f34233df755d2fb020c4d678f9.webp";